import { Sofa, Sun, Trees } from "lucide-react";
import { PhotoSlot } from "./PhotoSlot";
import { SectionTitle } from "./SectionTitle";
import { Reveal } from "./Reveal";

const ROOMS = [
    {
        slot: "sala",
        icon: Sofa,
        title: "Sala",
        text: "Il cuore del locale: tavoli all'interno, servizio al tavolo e i giochi da bar a portata di mano.",
    },
    {
        slot: "veranda",
        icon: Sun,
        title: "Veranda",
        text: "La zona coperta tra dentro e fuori: si resta in compagnia anche quando la serata si fa più fresca.",
    },
    {
        slot: "giardino",
        icon: Trees,
        title: "Giardino sul prato",
        text: "Tavoli all'aperto sul prato: il posto più amato nelle sere d'estate.",
    },
];

export const Venue = () => (
    <section id="locale" className="bg-superficie py-20 md:py-28">
        <div className="container-pub">
            <Reveal>
                <SectionTitle eyebrow="Il locale" title="Dentro, in veranda o sul prato" />
                <p className="mt-6 max-w-2xl text-avorio/85">
                    Il River Pub è un pub storico di Quarrata, rinnovato negli anni senza perdere il calore di una
                    volta. Si sta in sala, nella veranda o fuori sul prato, con birre, cocktail, gin e tè e una
                    cucina da pub fatta di hamburger, panini e taglieri. Alcune sere c'è la musica dal vivo, altre
                    un DJ set o una serata a tema. Sempre un posto dove ritrovarsi, giocare e fare due chiacchiere.
                </p>
            </Reveal>
            <div className="mt-10 grid sm:grid-cols-3 gap-6">
                {ROOMS.map((r, i) => (
                    <Reveal key={r.slot} delay={i * 0.08} className="h-full">
                        <article className="rounded-xl overflow-hidden border border-bordo bg-carbone h-full">
                            <PhotoSlot slotId={r.slot} icon={r.icon} ratio="aspect-[4/3]" />
                            <div className="p-5">
                                <h3 className="font-heading uppercase tracking-wide text-xl">{r.title}</h3>
                                <p className="mt-2 text-[15px] text-avorio/75">{r.text}</p>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);